var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46502 20C8.87842 20 16.265 12.1078 16.265 7.79999C16.265 3.49217 12.7728 0 8.46502 0C4.15721 0 0.665039 3.49217 0.665039 7.79999C0.665039 12.1078 8.05164 20 8.46502 20ZM8.46503 11.7013C10.6491 11.7013 12.4197 9.93071 12.4197 7.74665C12.4197 5.56258 10.6491 3.79205 8.46503 3.79205C6.28098 3.79205 4.51045 5.56258 4.51045 7.74665C4.51045 9.93071 6.28098 11.7013 8.46503 11.7013Z",
    fill: "#F57E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.13bcf9554b960a088f5fc844ef228a69.svg";
export { ForwardRef as ReactComponent };